// dashboard/UserDashboardTabs.jsx

import React from 'react';
import { Box, Tabs, Tab, Typography, Divider } from '@mui/material';
import UserDashboardStyles from './UserDashboard.styles';

const UserDashboardTabs = ({ tabValue, onTabChange, children }) => (
  <Box sx={UserDashboardStyles.container}>
    <Box sx={UserDashboardStyles.header}>
      <Typography variant="h4">User Dashboard</Typography>
    </Box>

    <Tabs value={tabValue} onChange={onTabChange} sx={UserDashboardStyles.tabs}>
      <Tab label="Overview" />
      <Tab label="Scheduled Viewings" />
      <Tab label="Saved Listings" />
      <Tab label="Settings" />
      <Tab label="Tenant Membership" />
    </Tabs>

    <Divider sx={{ marginY: '2rem' }} />

    <Box>{children}</Box>
  </Box>
);

export default UserDashboardTabs;
